import { render, staticRenderFns } from "./Gesamtabrechnung.vue?vue&type=template&id=244535a4&"
import script from "./Gesamtabrechnung.vue?vue&type=script&lang=js&"
export * from "./Gesamtabrechnung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports